import {mapGetters} from 'vuex';
import * as USER from '@/store/constants/user';
import Datepicker from 'vuejs-datepicker';

export default {
  inject: ['$validator'],
  name: "Add",
  components: {Datepicker},
  data() {
    return {
      appointment: {},
      setting: {
        place: 'Test Place.'
      }
    }
  },
  computed: {
    ...mapGetters({
      user: USER.GET_USER
    })
  },

  methods: {
    generate() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.$router.push({
            name: 'CertificatePreview',
            params: {user: this.user, appointment: this.appointment, setting: this.setting}
          });
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Certificate/js/create.js